import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchEnhancedFilterModel } from '../../../elasticsearch/elasticsearch-filter';
import LessThanFilterParser from '../../../osd/filters/parsers/less-than-filter-parser';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'LESS THAN' filter parser
 */
export class ExploreFilterLessThanFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(new LessThanFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        filter.type = 'LESS_THAN';
        filter.value = metadata.params;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'LESS_THAN' || !filter.field)
            return null;
        return { [this.baseFilterParser.elasticKey]: { [filter.field.name]: filter.value } };
    }
}
//# sourceMappingURL=less-than.js.map